import ReactDOM from 'react-dom';
import replayImage from '../../../../assets/images/replay_box.svg';
import replayImageActive from '../../../../assets/images/replay_box_active.svg';

export default class ControlBox {
    constructor(map, google, position) {
        this.map = (map || null);
        this.google = (google || null);
        this.position = (position || this.google.maps.ControlPosition.RIGHT_TOP);
        this.controlList = {};
    };

    add(params) {
        const { component, name, index } = params;
        if (this.getControl(name)) return;
        const prevIndex = (this.map.controls[this.position].length - 1);
        const control = document.createElement('div');
        control.id = `$control_${name}`;
        control.className = `map-card-container animate ${params.className || ''} ${params.className === "map-analyze-container" ? "animate__fadeInRight" : "animate__fadeInUp"}`;
        control.index = (prevIndex + (typeof index === "undefined" ? 1 : index));
        this.map.controls[this.position].push(control);
        ReactDOM.render(component, control, () => {
            this.controlList[name] = control
            if (params.onLoaded) params.onLoaded({ control, component });
        });
    }

    remove(name) {
        const controlBox = this.getControl(name);
        if (!controlBox) return;
        const index = Object.keys(this.controlList).indexOf(name);
        if (index < 0) return;
        delete this.controlList[name];
        this.map.controls[this.position].removeAt(index);
        ReactDOM.unmountComponentAtNode(controlBox);
    }

    removeAll() {
        for (const name in this.controlList) this.remove(name);
    }

    getControl(name) {
        return this.controlList.hasOwnProperty(name) ? this.controlList[name] : null;
    }

    getControls() {
        return this.controlList;
    }
}

export const getControlBox = (map, google, position) => {
    if (!map.__meta_controlbox) map.__meta_controlbox = {};
    const metaData = map.__meta_controlbox;
    if (!metaData.hasOwnProperty(position)) metaData[position] = new ControlBox(map, google, position);
    return metaData[position];
};

export const setActiveControl = (name, active) => {
    const container = document.getElementById(`$control_${name}`);
    const ctl = container ? container.firstChild : null;
    if (ctl) active ? ctl.classList.add("active") : ctl.classList.remove("active");
    if (name === 'ctlReplay' && ctl) {
        if (ctl.children.length > 0 && ctl.children[0].src) ctl.children[0].src = active ? replayImageActive : replayImage;
    }
};